<template>
  <div>
    <img
      src="@/assets/tarjeta_servicios_subsidio_paralizacion.jpg"
      style="width: 100%"
    />
    <p class="tituloTarjeta">SUBSIDIO POR PARALIZACIÓN</p>
    <p>
      La garantía de
      <b>Subsidio</b>
      , que tienes contratada en {{ textoPolizas }}, te compensa el perjuicio
      económico que supone el cese temporal de tu actividad profesional.
    </p>
    <p>Consulta las condiciones generales de la garantía</p>

    <p class="container-flex">
      <a href="tel:+ 34 91 594 88 38">
        <button
          class="pure-button botonLlamar"
          title="Pulse el botón para llamar a nuestro Centro de Atención al Cliente"
        >
          Llamar
        </button>
      </a>
    </p>
    <p class="container-flex">
      <a
        href="https://www.mmtseguros.com/hubfs/Documentacion_comun_seguro_coche/Subsidio-paralizacion-vehiculo.pdf"
        target="_blank"
        class="link"
        >Condicionado Ggeneral</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textoPolizas: "",
    };
  },

  created() {
    let numPolizas = this.$store.state.portfolio.polizasConSubsidioStr;
    if (this.$store.state.portfolio.cuantasPolizasConSubsidio == 1) {
      this.textoPolizas = " tu póliza: " + numPolizas;
    } else if (this.$store.state.portfolio.cuantasPolizasConSubsidio > 1) {
      this.textoPolizas = " tus pólizas: " + numPolizas;
    }
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>
